import store from '@/vuex/store';

let avisaEm30;
let avisaEm10;
let fechaApp;

export const avisaAntesDeTokenExpirar = app => {
  const faltam30 = 1770000;
  const faltam10 = 1790000;

  avisaEm30 = setTimeout(() => {
    app.$refs.toastr.w(
      'Salve suas alterações, a sessão vai expirar em 30 segundos',
      'Sessão vai expirar',
    );
  }, faltam30);

  avisaEm10 = setTimeout(() => {
    app.$refs.toastr.w(
      'Salve suas alterações, a sessão vai expirar em 10 segundos',
      'Sessão vai expirar',
    );
  }, faltam10);
};

export const forcaLogout = router => {
  const app = router.app;
  const expirou = 1800000;

  fechaApp = setTimeout(() => {
    app.isAuthenticated = false;
    store.commit('setToken', '');
    store.commit('setAutenticados', []);
    store.commit('setFuncionario', {});
    document.querySelector('.upper-off-canvas').classList.remove('fechado');
    document.querySelector('.off-canvas').classList.remove('fechado');
    router.push({ path: '/' });
  }, expirou);
};

export const cancelaAvisosEFechar = app => {
  app.$root.$refs.toastr.removeByType('success');
  app.$root.$refs.toastr.removeByType('warning');
  app.$root.$refs.toastr.removeByType('error');
  clearTimeout(avisaEm30);
  clearTimeout(avisaEm10);
  clearTimeout(fechaApp);
};



// WEBPACK FOOTER //
// ./src/router/tokenExpirado.js